module.exports = __webpack_public_path__ + "img/LV3.f9574879.webp";